<template>
  <div class="notification duration-500 ease-in-out transition transform-gpu" :class="[movedLeft, transitioned]">
    <div class="content" :class="type">

      <div class="close" :class="{ 'hidden': !closeBtnVisible }">
        <svg class="w-4 h-4 absolute top-2 right-1">
          <use xlink:href="#cross"/>
        </svg>
      </div>

      <header>{{ header }}</header>

      <main>
        <slot name="content">
          {{ message }}
        </slot>
      </main>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Notification',
  props: {
    type: {
      type: String,
      required: true
    },
    header: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    offset: {
      type: Boolean,
      required: false
    },
    active: {
      type: Boolean,
      required: true
    },
    closeBtnVisible: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    transitioned () {
      if (this.active) {
        return 'transitioned'
      }

      return ''
    },
    movedLeft () {
      // console.log('this.offset =', this.offset)
      if (this.offset) {
        return 'transform-gpu -translate-x-4'
      }

      return 'transform-gpu translate-x-0'
    }
  }
}
</script>

<style lang="postcss" scoped>
.notification {
  @apply absolute -top-36;
  @apply flex justify-center;
  @apply w-full max-h-36 overflow-y-scroll;
  @apply translate-y-0;
}
.notification.transitioned {
  @apply translate-y-56;
}

.content {
  @apply relative w-2/3 md:w-1/2 mx-auto p-3 rounded-md shadow-sm-intense;
}

.info {
  @apply bg-blue-600 text-blue-100;
  /*  border-l-4 border-blue-900; */
}
.warning {
  @apply bg-yellow-500 text-yellow-100 ;
  /* border-l-4 border-yellow-700; */
}
.error {
  @apply bg-red-500 text-red-100;
  /*  border-l-4 border-red-700; */
}
.success {
  @apply bg-green-600 text-green-100;
  /*  border-l-4 border-green-800; */
}

header {
  @apply font-bold mb-3 text-xs uppercase w-full;
}

main {

}
</style>
